module.exports = __webpack_public_path__ + "static/media/b2.3a964278.png";